import React from 'react';

export function StatusLabel({ status }: { status: string }) {
	return (
		<span style={{ marginLeft: -10 }} className="w-fit rounded-full p-2.5 py-1 text-base font-medium text-amber-700">
			{status}
		</span>
	);
}
